// Gotham Checkout — bat emblem (inherits color via currentColor).
export const BatLogo = ({ className = 'h-5 w-5' }) => (
  <svg viewBox="0 0 512 512" className={className} fill="currentColor" aria-hidden="true">
    <path d="M256 150c-12 18-32 29-56 29-4-19-19-31-38-31 6 15 3 31-8 43 16 6 28 19 34 35-18-7-38-5-54 6 20 5 36 18 45 36-14 1-27 7-36 17 33 1 60 22 73 52 7-15 17-27 30-35l10 14 10-14c13 8 23 20 30 35 13-30 40-51 73-52-9-10-22-16-36-17 9-18 25-31 45-36-16-11-36-13-54-6 6-16 18-29 34-35-11-12-14-28-8-43-19 0-34 12-38 31-24 0-44-11-56-29z" />
  </svg>
);

export default BatLogo;
